export class FiltersParamsMappingError extends Error {
  constructor(
    message: string,
    public code: number,
  ) {
    super(message);
    this.name = 'FiltersParamsMappingError';
  }
}
